import { loadLibraries } from "./libraries";
import type { LatLng, LatLngBounds } from "./types";

export const getZipCodeFromLatLng = async (apiKey: string, location: LatLng, bounds?: LatLngBounds): Promise<string> => {
  const { geocodingLibrary } = await loadLibraries(apiKey);

  const geocoding = new geocodingLibrary.Geocoder();

  const result = await geocoding.geocode({
    location,
    bounds,
  });

  let postalCode = null;

  for (const location of result.results) {
    postalCode = location.address_components?.find((f) => isPostalCode(f.types));

    if (postalCode) {
      break;
    }
  }

  if (!postalCode) {
    throw new Error("No postal code in this area");
  }

  return postalCode?.long_name;
};

const isPostalCode = (types: string[]) => types.includes("postal_code");

export const getLatLngFromAddress = async (apiKey: string, address: string): Promise<LatLng> => {
  const { geocodingLibrary } = await loadLibraries(apiKey);

  const geocoding = new geocodingLibrary.Geocoder();

  try {
    const result = await geocoding.geocode({ address });

    return result.results[0].geometry.location;
  } catch (e) {
    throw new Error("No location found for this address");
  }
};
